/***
 * Copyright (c) Myia 2023-2025 - All Rights Reserved
 */

import { useCheckOrg } from '@/net/commons';

export default function GeneralSettings() {
    const { organisation } = useCheckOrg();

    return (
        <div className="mt-10">
            <div className="rounded-xl border p-6 space-y-8">
                <h2 className="font-semibold leading-none tracking-tight">Organisation Information</h2>
                <div className="grid grid-cols-3">
                    <p className="text-sm font-medium leading-none">Organisation Name</p>

                    <p className="text-sm leading-none text-muted-foreground col-span-2">{organisation?.name}</p>
                </div>
            </div>
        </div>
    );
}
